import React from "react";

function AppleIcon ({className}) {
  return (
    <svg
      className={className}
      xmlns="http://www.w3.org/2000/svg"
      width="28"
      height="28"
      fill="none"
      viewBox="0 0 28 28"
    >
      <path
        fill="#000"
        d="M19.388 0h.2c.16 1.975-.594 3.45-1.51 4.519-.899 1.06-2.13 2.09-4.12 1.934-.133-1.947.622-3.313 1.537-4.379.848-.993 2.403-1.877 3.893-2.074zM25.414 20.553v.055c-.56 1.694-1.357 3.146-2.33 4.494-.89 1.223-1.98 2.87-3.924 2.87-1.681 0-2.797-1.081-4.52-1.11-1.822-.03-2.824.903-4.49 1.138h-.568c-1.224-.177-2.211-1.146-2.93-2.019-2.121-2.58-3.76-5.911-4.065-10.175v-1.253C2.716 11.5 4.199 9.02 6.17 7.817c1.04-.639 2.47-1.184 4.062-.94.683.105 1.38.34 1.99.57.58.223 1.304.617 1.99.597.465-.014.927-.256 1.396-.427 1.372-.496 2.717-1.064 4.49-.797 2.13.322 3.643 1.27 4.577 2.73-1.802 1.147-3.227 2.876-2.984 5.828.217 2.681 1.776 4.25 3.723 5.175z"
      ></path>
    </svg>
  );
}

export default AppleIcon;